import React from 'react';
import { Snackbar } from '@mui/material';

const CustomSnackbar = ({ open, onClose, message, autoHideDuration }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      onClose={onClose}
      message={message}
      autoHideDuration={autoHideDuration}
      sx={{
        // background: 'linear-gradient(135deg, #323232 0%, #4a4a4a 100%)',
        backgroundColor: '#4a4a4a', // Slightly lighter than #323232
        color: '#ffffff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        // border: '1px solid #FF9800',
        // padding: '12px 24px',
        fontSize: '20px',
        borderRadius: '8px',
        zIndex: 9999,
        mt: 7,
        // mr: 1,
        animation: 'slideInRight 0.5s ease-out',
        '@keyframes slideInRight': {
          '0%': {
            transform: 'translateX(100%)',
          },
          '100%': {
            transform: 'translateX(0)',
          },
        },
      }}
    />
  )
};

export default CustomSnackbar;


// import { Snackbar, Alert, useMediaQuery, useTheme } from '@mui/material'
// const CustomSnackbar = ({
//   open,
//   message,
//   severity = 'info',
//   autoHideDuration = 3000,
//   onClose,
//   anchorOrigin,
//   sx,
// }) => {
//   const theme = useTheme()
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

//   // Default colors based on the application's theme
//   const colors = {
//     primary: '#232536',
//     secondary: '#ffcf51',
//     success: '#43a047',
//     error: '#d32f2f',
//     warning: '#ffcf51',
//     info: '#232536',
//   }

//   // Default position that prioritizes visibility, especially on mobile
//   const defaultAnchorOrigin = {
//     vertical: isSmallScreen ? 'top' : 'bottom',
//     horizontal: 'center',
//   }

//   return (
//     <Snackbar
//       open={open}
//       autoHideDuration={autoHideDuration}
//       onClose={onClose}
//       anchorOrigin={anchorOrigin || defaultAnchorOrigin}
//     >
//       <Alert
//         onClose={onClose}
//         severity={severity}
//         variant='filled'
//         sx={{
//           backgroundColor:
//             severity === 'warning'
//               ? colors.warning
//               : severity === 'error'
//               ? colors.error
//               : severity === 'success'
//               ? colors.success
//               : colors.primary,
//           color: severity === 'warning' ? colors.primary : '#fff',
//           borderRadius: '8px',
//           boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
//           ...sx?.['& .MuiAlert-root'],
//         }}
//       >
//         {message}
//       </Alert>
//     </Snackbar>
//   )
// }